document.querySelectorAll('.js-toggleFAQ').forEach((trigger) => {
  trigger.addEventListener('click', () => {
    const item = trigger.closest('.bFaq__item')
    if (!item) {
      return
    }

    item.classList.toggle('is-open')
  })
})
